import React from 'react'
import { FaCloudDownload } from 'react-icons/lib/fa'

import profilePic from '../assets/images/july2017headshot.jpeg'

const About = () => (
  <section id="about">
    <div className="row">
      <div className="three columns">
        <img className="profile-pic" src={profilePic} alt="" />
      </div>
      <div className="nine columns main-col">
        <h2>About Me</h2>
        <p>
          Hi, I'm William. I've spent the past 8 years working in
          technical roles at small-to-mid sized companies, primarily
          startups. Currently, I am building Meisterwerk - a construction
          technology startup, where I own and execute engineering decisions and 
          directly manage the technical organization. Previously, I was Head of 
          Product at Jovio, a real estate technology startup based in Austin, TX. 
          There I hired and managed the product and engineering team and was responsible 
          for bridging the gap between stakeholder requirements and product development. 
          Prior to that, I co-founded an online translation services provider catering to
          high-touch marketing agencies in NYC. My strengths are in understanding both 
          technical and non-technical sides of an organization and being able to work with 
          both to bring a business to life with technology.
        </p>
        <div className="row">
          <div className="columns contact-details">
            <h2>Contact Details</h2>
            <p className="address">
              <span>William Birtwell</span>
              <br />
              <a
                href="mailto:william@birtwell.io"
                target="_blank"
                rel="noopener noreferrer"
              >william@birtwell.io</a>
            </p>
          </div>
          <div className="columns download">
            <p>
              <a
                href="https://birtwell.io/static/birtwell_william_CV_2019.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="button"
              >
                <FaCloudDownload /> Download Resume
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default About



// WEBPACK FOOTER //
// ./src/components/About.js